import { styled } from '@mui/material';
import { MembersTab } from 'components/CourseDashboard';
import { Box, Container } from 'shell/components';

const Desktop = ({ course, accountUsers, sendInvitations, removeUser }) => {
    return (
        <Container device={'desktop'}>
            <RootBox>
                <MembersTab
                    isInCourseDashboard={false}
                    course={course}
                    accountUsers={accountUsers?.filter((accountUser) => accountUser.active)}
                    sendInvitations={sendInvitations}
                    removeUser={removeUser}
                />
            </RootBox>
        </Container>
    );
};

const RootBox = styled(Box)(({ theme }) => {
    return {
        borderRadius: '12px 12px 0 0',
        width: '100%',
        minHeight: 'calc(100vh - 64px - 20px)',
        padding: theme.spacing(5, 5, 0),
        background: theme.palette.ensightful.shades[0],
    };
});

export default Desktop;
